import React from "react";

// <?xml version="1.0" encoding="UTF-8"?>
// Creator: CorelDRAW 2019 (64-Bit)
// <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
// xmlns:Xodm={"http://www.corel.com/coreldraw/odm/2003"}

export const EthereumIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.12793 19.2568L0.425781 11.3174L6.12793 14.6455L11.834 11.3174L6.12793 19.2568ZM11.8311 10.0029L6.12891 13.333L6.12793 13.332V13.333L0.425781 10.0029L6.12793 0.900391V0.904297L6.12891 0.900391L11.8311 10.0029Z"
      fill="#272727"
    />
  </svg>
);
